module.exports = __webpack_public_path__ + "static/prisoners-of-geography-41d4cd6c6749e75208d32a09b2741c0a.jpg";